/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_Point_0_LabelInputs */

const en_visa_e2_extra_point_0_label = /** @type {(inputs: Visa_E2_Extra_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationality and Ownership`)
};

const pt_visa_e2_extra_point_0_label = /** @type {(inputs: Visa_E2_Extra_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacionalidade e Propriedade`)
};

const es_visa_e2_extra_point_0_label = /** @type {(inputs: Visa_E2_Extra_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacionalidad y Propiedad`)
};

/**
* | output |
* | --- |
* | "Nationality and Ownership" |
*
* @param {Visa_E2_Extra_Point_0_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_point_0_label = /** @type {((inputs?: Visa_E2_Extra_Point_0_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_Point_0_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_point_0_label(inputs)
	if (locale === "es") return es_visa_e2_extra_point_0_label(inputs)
	return en_visa_e2_extra_point_0_label(inputs)
});